
export const updateCart = (product, cart, action, cases, bottles) => {
    switch (action) {
        case "REMOVE" : {
            let updatedItems = cart.items.filter(el => el.Code !== product.Code && el._parentProductCode !== product.Code)
            return {
                ...cart,
                items: updatedItems
            }
        }
        case "ADD" : {
            let productPayload = {...product} // Clone product to avoid mutations
            productPayload.CasesQty = cases
            productPayload.BottlesQty = bottles

            let updatedItems = [...cart.items] // Clone items array
            const existingIndex = updatedItems.findIndex(el => el.Code === productPayload.Code)

            if (existingIndex >= 0) {
                // Update existing item
                updatedItems[existingIndex] = {
                    ...updatedItems[existingIndex],
                    CasesQty: productPayload.CasesQty,
                    BottlesQty: productPayload.BottlesQty
                }
            } else {
                // Add new item
                updatedItems.push(productPayload)
            }

            return {
                ...cart,
                items: updatedItems
            }
        }
        default:
            return cart
    }

}